<template>
  <div id="app">
    <div class="banner-container" ref="headerTop">
      <div class="banner-content box1200">
      </div>
    </div>
    <main class="main" ref="myDiv">
      <div class="box1200" >
        <div class="content-container">
          <router-view/>
        </div>
      </div>
    </main>
  </div>
  
</template>

<script>
var src = 'https://zwfw.gansu.gov.cn/cms_files/filemanager/892888968/picture/20233/4502811a4f6742e9ba5875498faf4ffe.png'
var src2 = 'https://zwfw.gansu.gov.cn/szgs/resources/front/hdjl/success/images/message-bg.png'
var src3 = 'https://zwfw.gansu.gov.cn/cms_files/filemanager/892888968/picture/20234/1610aa1246d04629b8158d313487af03.png'
export default {
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
    };
  },
  created(){
    window.onresize = () => {
        return (() => {
          window.fullWidth = document.documentElement.clientWidth;
          this.windowWidth = window.fullWidth; //获取屏幕宽度
        })()
    };
  },
  mounted(){
    if(this.windowWidth<=768){
      this.$refs.headerTop.style.backgroundImage = `url(${src3})`
      this.$refs.headerTop.style.margin = '0'
    }
  },
  methods: {

  },
  watch: {
    $route: {
      handler: function(val){
        if(val.fullPath == '/index'){
          this.$refs.myDiv.style.backgroundImage = `url(${src})`
          this.$refs.myDiv.style.backgroundSize = '55% 100%'
          this.$refs.myDiv.style.backgroundPostion = 'top left'
          this.$refs.myDiv.style.backgroundRepeat = 'no-repeat'
          this.$refs.headerTop.style.height = ' 4.47rem'
          if(this.windowWidth<=750){
            this.$refs.myDiv.style.background = 'none'
          }
        }else{
          this.$refs.myDiv.style.background = 'none'
        }
        if(val.fullPath == '/jactSuccess'){
          this.$refs.myDiv.style.backgroundImage = `url(${src2})`
          this.$refs.myDiv.style.backgroundSize = '100%'
          this.$refs.myDiv.style.backgroundPostion = 'center center'
          this.$refs.myDiv.style.backgroundRepeat = 'no-repeat'
           this.$refs.headerTop.style.height = '0'
        }else{
          this.$refs.headerTop.style.height = ' 4.47rem'
        }
      },
      // 深度观察监听
      deep: true
    },
  }
};
</script>
<style lang="less" scope="scope">
.title{
  font-size: 30px;
  font-weight: 600;
  color: white;
  padding-top: 30px;
}
.title-text{
  font-size: 18px;
  color: white;
  margin-top: 10px;
}
</style>
